'use client';

// Client-only components that require interactivity or use hooks internally
export { CatButton } from '@blocks-react/components/Button';
export { CatDropdown } from '@blocks-react/components/Dropdown';
export { CatPagination } from '@blocks-react/components/Pagination';
export { CatTabs } from '@blocks-react/components/Tabs';
export { CatTab } from '@blocks-react/components/Tab';
export { CatTabPanel } from '@blocks-react/components/TabPanel';
export { CatModal } from '@blocks-react/components/Modal';
export { CatDrawer } from '@blocks-react/components/Drawer';
export { CatToast } from '@blocks-react/components/Toast';
export { CatToastGroup } from '@blocks-react/components/ToastGroup';
export { CatInputField } from '@blocks-react/components/InputField';
export { CatTextareaField } from '@blocks-react/components/TextareaField';
export { CatCheckboxField } from '@blocks-react/components/CheckboxField';
export { CatRadioField } from '@blocks-react/components/RadioField';
export { CatToggle } from '@blocks-react/components/Toggle';
export { CatNumericInput } from '@blocks-react/components/NumericInput';
export { CatQuantityPicker } from '@blocks-react/components/QuantityPicker';
export { CatSlider } from '@blocks-react/components/Slider';
export { CatSearchForm } from '@blocks-react/components/SearchForm';
export { CatDaterangepickerField } from '@blocks-react/components/DaterangepickerField';
export { CatDatepickerField } from '@blocks-react/components/DatepickerField';
export { CatFileUpload } from '@blocks-react/components/FileUpload';
export { CatAccordion } from '@blocks-react/components/Accordion';
export { CatAccordionPanel } from '@blocks-react/components/AccordionPanel';
export { CatSegmentedControl } from '@blocks-react/components/SegmentedControl';
export { CatSegmentedControlItem } from '@blocks-react/components/SegmentedControlItem';
export { CatCarousel } from '@blocks-react/components/Carousel';
export { CatCarouselItem } from '@blocks-react/components/CarouselItem';
export { CatImageGallery } from '@blocks-react/components/ImageGallery';
export { CatImageGalleryItem } from '@blocks-react/components/ImageGalleryItem';
export { CatImageGalleryThumbnail } from '@blocks-react/components/ImageGalleryThumbnail';
export { CatImageGalleryThumbnailItem } from '@blocks-react/components/ImageGalleryThumbnailItem';
export { CatTooltip } from '@blocks-react/components/Tooltip';
export { CatPopover } from '@blocks-react/components/Popover';
export { CatContextualMenu } from '@blocks-react/components/ContextualMenu';
export { CatSideMenu } from '@blocks-react/components/SideMenu';
export { CatSideMenuItem } from '@blocks-react/components/SideMenuItem';
export { CatAnchorNav } from '@blocks-react/components/AnchorNav';
export { CatAnchorNavItem } from '@blocks-react/components/AnchorNavItem';

// Components that use hooks internally (moved from static due to useRef errors)
export { CatCard } from '@blocks-react/components/Card';
export { CatHeader } from '@blocks-react/components/Header';
export { CatPrimaryNavItem } from '@blocks-react/components/PrimaryNavItem';
export { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
export { CatLayout } from '@blocks-react/components/Layout';
export { CatLayoutSection } from '@blocks-react/components/LayoutSection';
export { CatGrid } from '@blocks-react/components/Grid';
export { CatGridItem } from '@blocks-react/components/GridItem';
export { CatList } from '@blocks-react/components/List';
export { CatListItem } from '@blocks-react/components/ListItem';
export { CatTable } from '@blocks-react/components/Table';
export { CatTableHeader } from '@blocks-react/components/TableHeader';
export { CatTableRow } from '@blocks-react/components/TableRow';
export { CatTableHeaderCell } from '@blocks-react/components/TableHeaderCell';
export { CatTableBody } from '@blocks-react/components/TableBody';
export { CatTableCell } from '@blocks-react/components/TableCell';
export { CatTableObject } from '@blocks-react/components/TableObject';
export { CatChipGroup } from '@blocks-react/components/ChipGroup';
export { CatInlineNotification } from '@blocks-react/components/InlineNotification';
export { CatBreadcrumbs } from '@blocks-react/components/Breadcrumbs';
export { CatBreadcrumbsItem } from '@blocks-react/components/BreadcrumbsItem';
export { CatStatusIndicator } from '@blocks-react/components/StatusIndicator';
export { CatLoadingIndicator } from '@blocks-react/components/LoadingIndicator';
export { CatChip } from '@blocks-react/components/Chip';
export { CatHeading } from '@blocks-react/components/Heading';
export { CatSkeleton } from '@blocks-react/components/Skeleton';
export { CatTextLink } from '@blocks-react/components/TextLink';

// Event types for interactive components
export type {
  BlocksCloseEvent,
  BlocksSelectEvent,
  BlocksFileAddEvent,
  BlocksChangeEvent,
  BlocksDateRangeEvent,
  BlocksCheckboxChangeEvent,
  BlocksRowCellSelectEvent,
  BlocksRowCellSelectAllEvent,
  BlocksQuantityPickerChangeEvent
} from '@blocks-web-components/events/';

export type {
  SelectValue,
  CommonMessageTypes
} from '@blocks-web-components/util/common-modal';

export type { BlocksDaterangepickerField } from '@blocks-web-components/components/daterangepicker-field/daterangepicker-field';
export type { BlocksDatepickerField } from '@blocks-web-components/components/datepicker-field/datepicker-field';
export type { BlocksElement } from '@blocks-web-components/components/BlocksElement';
export type { FileUploadTextConfig } from '@blocks-web-components/components/file-upload/file-upload.model';
